import {
  FaInstagram,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneSquare,
  FaFacebook
} from 'react-icons/fa'

import * as S from './styles'
import * as Global from '../../styles/index'
import * as Txt from '../../styles/text'

import { useGetContatoQuery } from '../../services/api'

const ContatoTabletDesktop = () => {
  const { data: contato } = useGetContatoQuery()

  // if (!contato) {
  //   return <h3>Carregando...</h3>
  // }

  return (
    <>
      <S.Container id="contato">
        <Global.Container>
          <S.ListGrid className="col-md-7 d-flex justify-between mx-auto">
            {/* Coluna 1 - Info de contato */}
            <ul>
              <li>
                <S.ListItemBlock>
                  <S.ListIconBlock>
                    <FaPhoneSquare size={30} />
                  </S.ListIconBlock>
                  {contato ? (
                    <a
                      href={`https://wa.me/${contato.tel.replace(/[\s*#@-]+/g, '').trim()}`}
                    >
                      <S.ContatoText>+81 090 6464-2904</S.ContatoText>
                    </a>
                  ) : (
                    <div className="placeholder-glow">
                      <span className="placeholder col-8 me-2 mt-2" />
                    </div>
                  )}
                </S.ListItemBlock>
              </li>
              <li>
                <S.ListItemBlock>
                  <S.ListIconBlock>
                    <FaMapMarkerAlt size={30} />
                  </S.ListIconBlock>
                  {contato ? (
                    <a href={contato.endereco_link}>
                      <S.ContatoText>{contato.endereco}</S.ContatoText>
                    </a>
                  ) : (
                    <div className="placeholder-glow">
                      <span className="placeholder col-8 me-2 mt-2" />
                    </div>
                  )}
                </S.ListItemBlock>
              </li>
              <li>
                <S.ListItemBlock>
                  <S.ListIconBlock>
                    <FaEnvelope size={30} />
                  </S.ListIconBlock>
                  {contato ? (
                    <a href={`mailto:${contato.email}`}>
                      <S.ContatoText>{contato.email}</S.ContatoText>
                    </a>
                  ) : (
                    <div className="placeholder-glow">
                      <span className="placeholder col-8 me-2 mt-2" />
                    </div>
                  )}
                </S.ListItemBlock>
              </li>
            </ul>

            {/* Coluna 2 - Redes sociais */}
            <ul>
              <li>
                <S.ListItemFlex>
                  {contato ? (
                    <a href={contato.facebook_link}>
                      <S.ListSocialIcon>
                        <FaFacebook size={35} />
                        <S.ContatoText>Cantinho da Tia Chechela</S.ContatoText>
                      </S.ListSocialIcon>
                    </a>
                  ) : (
                    <S.IconPlaceholder className="card-text placeholder-glow">
                      <span className="placeholder col-8 me-2 mt-2"></span>
                    </S.IconPlaceholder>
                  )}
                  {contato ? (
                    <a href={contato.instagram_link}>
                      <S.ListSocialIcon>
                        <FaInstagram size={35} />
                        <S.ContatoText>@cantinhodatiachechela</S.ContatoText>
                      </S.ListSocialIcon>
                    </a>
                  ) : (
                    <S.IconPlaceholder className="card-text placeholder-glow">
                      <span className="placeholder col-8 me-2 mt-2"></span>
                    </S.IconPlaceholder>
                  )}
                </S.ListItemFlex>
              </li>
            </ul>
          </S.ListGrid>
        </Global.Container>
      </S.Container>
    </>
  )
}

export default ContatoTabletDesktop
